<template>
  <div class="list-wrap" v-if="permission" :class="isSideMenuClosed ? 'collapsed' : ''">
    <!-- ヘッダー部分 -->
    <div class="header-individual" :class="header_notification ? 'header-notification-space' : ''" v-if="view_report_enabled && permission.access">
      <div class="header-search-wrap">
        <font-awesome-icon :icon="['fas', 'search']" style="font-size:16px; color:#aaa; margin-right:10px" />
        <el-input class="head-search list clearable" placeholder="レポートを検索" clearable v-model="search_report" @input="searchList"></el-input>
      </div>
    </div>
    <!-- ユーザーページ -->
    <div class="list-page-wrap">
      <div class="data-table-title">
        <div style="display:flex; flex-flow:row; align-items:center">
          <span style="margin-right:20px">レポート・トラッキング</span>
          <div class="list-user-sort-wrap" v-if="client_select.target_client_id != 'all'">
            <div class="list-user-sort">
              <img :src="client_select.img_url" class="list-member-profile-sidemenu" v-if="client_select.img_url != null" />
              <div v-else class="list-member-noimg">{{ client_select.target_client_name | firstLetter }}</div>
              {{ client_select.target_client_name }}のレポート
              <font-awesome-icon :icon="['fas', 'times-circle']" style="margin-left: 5px; color:#666" class="pointer" @click="selectClient(all_client)" />
            </div>
          </div>
          <div class="list-user-sort-wrap" v-if="member_select.person_id != 'all'">
            <div class="list-user-sort">
              <img :src="member_select.img_url" class="list-member-profile-sidemenu" v-if="member_select.img_url != null" />
              <div v-else class="list-member-noimg">{{ member_select.person_name | firstLetter }}</div>
              {{ member_select.person_name }}のレポート
              <font-awesome-icon :icon="['fas', 'times-circle']" style="margin-left: 5px; color:#666" class="pointer" @click="selectMember(all_member)" />
            </div>
          </div>
        </div>
        <div class="flex-space"></div>
        <div class="report-title-num-box" v-if="!view_report_enabled">
          <div class="report-title-num">
            <div>レポート数</div>
            <div class="report-title-num-bottom">{{ active_report_count }}/10</div>
          </div>
        </div>
        <div class="data-table-menu" v-show="view_report_enabled">
          <el-tooltip :disabled="!create_report_limited">
            <div slot="content">レポートの上限数に達しています</div>
            <span>
              <el-button type="success" icon="el-icon-plus" @click="openCreateReport" :disabled="create_report_limited">新規レポート作成</el-button>
            </span>
          </el-tooltip>
        </div>
      </div>

      <div class="data-table-list" :class="header_notification ? 'header-notification-space-120' : ''">
        <div
          class="data-table-list-namearea pointer data-table-th-line thread"
          @click="view_report_enabled ? sortBy('report_name') : ''"
          :class="[sort_key === 'report_name' ? 'data-table-sort-active' : '']"
        >
          レポートタイトル
          <font-awesome-icon
            v-if="sort_key == 'report_name'"
            :icon="['fas', sort_key == 'report_name' && sort_order == 'asc' ? 'arrow-up' : sort_key == 'report_name' && sort_order == 'desc' ? 'arrow-down' : '']"
            style="margin-left: 3px"
          />
        </div>
        <div class="data-table-th-100 pointer data-table-th-line" @click="view_report_enabled ? sortBy('influencer_num') : ''" :class="[sort_key === 'influencer_num' ? 'data-table-sort-active' : '']">
          <el-tooltip placement="top">
            <div slot="content">[投稿済みのインフルエンサー] of [全インフルエンサー] を表示しています。</div>
            <span class="data-table-underline">インフルエンサー数</span>
          </el-tooltip>
          <font-awesome-icon
            v-if="sort_key == 'influencer_num'"
            :icon="['fas', sort_key == 'influencer_num' && sort_order == 'asc' ? 'arrow-up' : sort_key == 'influencer_num' && sort_order == 'desc' ? 'arrow-down' : '']"
            style="margin-left: 3px"
          />
        </div>
        <div class="data-table-list-num pointer data-table-th-line" @click="view_report_enabled ? sortBy('post_num') : ''" :class="[sort_key === 'post_num' ? 'data-table-sort-active' : '']">
          <span class="data-table-underline">投稿数</span>
          <font-awesome-icon
            v-if="sort_key == 'post_num'"
            :icon="['fas', sort_key == 'post_num' && sort_order == 'asc' ? 'arrow-up' : sort_key == 'post_num' && sort_order == 'desc' ? 'arrow-down' : '']"
            style="margin-left: 3px"
          />
        </div>
        <div
          class="data-table-list-num pointer data-table-th-line"
          @click="view_report_enabled ? sortBy('average_engagement_rate') : ''"
          :class="[sort_key === 'average_engagement_rate' ? 'data-table-sort-active' : '']"
        >
          <span class="data-table-underline">平均EGR</span>
          <font-awesome-icon
            v-if="sort_key == 'average_engagement_rate'"
            :icon="['fas', sort_key == 'average_engagement_rate' && sort_order == 'asc' ? 'arrow-up' : sort_key == 'average_engagement_rate' && sort_order == 'desc' ? 'arrow-down' : '']"
            style="margin-left: 3px"
          />
        </div>
        <div
          class="data-table-list-followers pointer data-table-th-line"
          @click="view_report_enabled ? sortBy('followers_count') : ''"
          :class="[sort_key === 'followers_count' ? 'data-table-sort-active' : '']"
        >
          <span class="data-table-underline">フォロワー<br />合計数 </span>
          <font-awesome-icon
            v-if="sort_key == 'followers_count'"
            :icon="['fas', sort_key == 'followers_count' && sort_order == 'asc' ? 'arrow-up' : sort_key == 'followers_count' && sort_order == 'desc' ? 'arrow-down' : '']"
            style="margin-left: 3px"
          />
        </div>
        <div
          class="data-table-list-gender pointer data-table-th-line"
          @click="view_report_enabled ? sortBy('female_ratio_done') : ''"
          :class="[sort_key === 'female_ratio_done' ? 'data-table-sort-active' : '']"
        >
          <span class="data-table-underline">フォロワー<br />男女比</span>
          <font-awesome-icon
            v-if="sort_key == 'female_ratio_done'"
            :icon="['fas', sort_key == 'female_ratio_done' && sort_order == 'asc' ? 'arrow-up' : sort_key == 'female_ratio_done' && sort_order == 'desc' ? 'arrow-down' : '']"
            style="margin-left: 3px"
          />
        </div>
        <div class="data-table-list-client pointer data-table-th-line" :class="[sort_key === 'list_status' ? 'data-table-sort-active' : '']" v-if="manage_brand_enabled">
          <el-dropdown trigger="click" placement="bottom-start">
            <div>
              <div v-if="client_select.target_client_id == 'all'">
                ブランド
                <font-awesome-icon :icon="['fas', 'caret-down']" style="margin-left:5px" />
              </div>
              <div class="list-detail-side-member" v-else>
                <img :src="client_select.img_url" class="list-member-profile-sidemenu" v-if="client_select.img_url != null" />
                <div v-else class="list-member-noimg">{{ client_select.target_client_name | firstLetter }}</div>
                <font-awesome-icon :icon="['fas', 'caret-down']" style="margin-left:5px" />
              </div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="selectClient(all_client)" :class="client_select.target_client_id == 'all' ? 'assign' : ''">全てのブランド</el-dropdown-item>
              <el-dropdown-item
                style="font-size:12px;"
                v-for="clientAll in target_client"
                :key="clientAll.id"
                class="member"
                @click.native="selectClient(clientAll)"
                :class="client_select.target_client_id == clientAll.target_client_id ? 'assign' : ''"
              >
                <img :src="clientAll.img_url" class="list-member-profile dropdown" v-if="clientAll.img_url != null" />
                <div class="list-member-noimg dropdown" v-else>{{ clientAll.target_client_name | firstLetter }}</div>
                <div class="list-member-dropdown-namearea">
                  <div>{{ clientAll.target_client_name }}</div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="data-table-list-member pointer data-table-th-line" :class="[sort_key === 'list_status' ? 'data-table-sort-active' : '']" v-if="manage_brand_enabled">
          <el-dropdown trigger="click" placement="bottom-start">
            <div>
              <div v-if="member_select.person_id == 'all'">
                メンバー
                <font-awesome-icon icon="caret-down" style="margin-left:5px" />
              </div>
              <div class="list-detail-side-member" v-else>
                <img :src="member_select.img_url" class="list-member-profile-sidemenu" v-if="member_select.img_url != null" />
                <div v-else class="list-member-noimg">{{ member_select.person_name | firstLetter }}</div>
                <font-awesome-icon icon="caret-down" style="margin-left:5px" />
              </div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="selectMember(all_member)" :class="member_select.person_id == 'all' ? 'assign' : ''">全てのメンバー</el-dropdown-item>
              <el-dropdown-item
                style="font-size:12px;"
                v-for="member in member"
                :key="member.id"
                class="member"
                @click.native="selectMember(member)"
                :class="member_select.person_id == member.person_id ? 'assign' : ''"
              >
                <img :src="member.img_url" class="list-member-profile dropdown" v-if="member.img_url != null" />
                <div class="list-member-noimg dropdown" v-else>{{ member.person_name | firstLetter }}</div>
                <div class="list-member-dropdown-namearea">
                  <div>{{ member.person_name }}</div>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="data-table-th-90">管理</div>
      </div>

      <!-- テーブルループ -->
      <unpermitted v-if="!permission.access" />
      <div class="data-table-list-nolist" v-if="permission.access && (nolist || !view_report_enabled)">
        <img src="../../assets/report_image_2.png" style="opacity: 0.5" alt />
        <div style="font-size: 20px; font-weight: 700; margin-bottom: 15px">
          レポートがありません
        </div>
        <div class="data-table-list-nolist-content">
          レポートを作成すると、投稿の一元管理や推移データの閲覧ができます。
          <br />インフルエンサーとトラッキングタグを追加してレポートを作成してみましょう。
        </div>
        <el-tooltip placement="top" :disabled="view_report_enabled">
          <div class="activate-popover" slot="content">
            <div class="pointer" @click="toSetting">アップグレード</div>
            でご利用いただけます
          </div>
          <div class="flex-row">
            <el-button type="success" :disabled="!view_report_enabled" @click="view_report_enabled ? openCreateReport() : ''" icon="el-icon-plus">新規レポート作成</el-button>
            <el-button type="primary" @click="openReport('demo')" v-if="view_report_enabled">デモを表示</el-button>
          </div>
        </el-tooltip>
      </div>

      <div
        v-for="(list, index) in list"
        :key="list.id"
        class="data-table-list-tr"
        v-show="permission.access && view_report_enabled && !nolist && list.report_name.match(search_report_regexp)"
        :style="list.create_status == 'wait' || list.create_status == 'creating' ? 'opacity:0.5;' : ''"
      >
        <div class="data-table-list-openwrap pointer" @click="list.create_status == 'wait' || list.create_status == 'creating' ? loadReport() : openReport(list.report_id)">
          <div class="data-table-list-imagearea">
            <div class="data-table-list-image">
              <el-image :src="list.img_url" class="list_img" v-if="list.img_url != null">
                <div slot="error" class="data-table-profile-noimg">
                  NO
                  <br />IMAGE
                </div>
              </el-image>
              <div class="data-table-list-noimg" v-else>
                <font-awesome-icon :icon="['far', 'chart-bar']" />
              </div>
            </div>
          </div>
          <div class="data-table-list-name">
            <div class="data-table-list-name-name">{{ list.report_name }}</div>
            <div class="data-table-list-name-sub" v-if="list.create_status != 'wait' && list.create_status != 'creating'">
              <span v-if="list.mentiontag != '' && list.report_type != 'manual'">
                <span v-for="mentiontag in list.mentiontag" :key="mentiontag.id">{{ mentiontag }}&nbsp;</span>・
              </span>
              <span v-if="list.hashtag != '' && list.report_type != 'manual'">
                <span v-for="hashtag in list.hashtag" :key="hashtag.id">{{ hashtag }}&nbsp;</span>・
              </span>
              <span v-if="list.keyword != '' && list.keyword != null && list.report_type != 'manual'">
                <span>{{ list.keyword.join(', ') }}&nbsp;</span>・
              </span>
              <span v-if="list.trackingtag == 'off'">トラッキングタグ: 設定しない・</span>
              <span v-if="list.report_type == 'manual'">
                <font-awesome-icon :icon="['fal', 'file-csv']" style="margin-right: 3px;" />
                Excelよりインポート・</span
              >
              作成&nbsp;{{ list.created_at | lastUpadate }}
            </div>
            <div class="data-table-list-name-sub" v-else>
              <span v-if="list.create_progress == 0">
                レポート作成待機中です(作成開始まで1分程度かかります) - クリックで作成状況を更新
              </span>
              <span v-else> レポートを作成中です({{ list.create_progress }}%) - クリックで作成状況を更新</span>
            </div>
          </div>
          <div class="data-table-th-100" style="padding: 0px 10px">
            <span v-if="list.influencer_num > 0">{{ list.influencer_num_done }} of {{ list.influencer_num }}</span>
          </div>
          <div class="data-table-list-num" style="padding: 0px 10px">
            <span>{{ list.post_num }}</span>
          </div>
          <div class="data-table-list-num" style="padding: 0px 10px">
            {{ list.average_engagement_rate_done == 0 ? "-" : list.average_engagement_rate_done == null ? "-" : list.average_engagement_rate_done + "%" }}
          </div>
          <div class="data-table-list-followers" style="padding: 0px 10px">
            {{ list.followers_count_done == 0 ? "-" : list.followers_count_done == null ? "-" : list.followers_count_done | addComma }}
          </div>
          <div class="data-table-list-gender" style="padding-left: 10px">
            {{ list.female_ratio_done == 0 ? "-" : list.female_ratio_done == null ? "-" : "" }}
            {{ list.sns_type == "youtube" ? "-" : "" }}
            <el-tooltip placement="top" v-if="list.sns_type == 'instagram'">
              <div slot="content">女性:{{ list.female_ratio_done }}%&nbsp;&nbsp;男性:{{ list.male_ratio_done }}%</div>
              <div class="gender-bar-list" v-show="list.female_ratio_done != 0">
                <div class="female-box-list" :style="'width:' + list.female_ratio_done + '%'"></div>
                <div class="male-box-list" :style="'width:' + list.male_ratio_done + '%'"></div>
              </div>
            </el-tooltip>
          </div>
        </div>
        <brandDropdown :id="list.report_id" :list="list" :target_client="target_client" :index="index" @changeTargetClient="changeTargetClient" @deleteClient="deleteClient" v-if="manage_brand_enabled" />
        <memberDropdown :id="list.report_id" :list="list" :index="index" @addMember="addMember" @deleteMember="deleteMember" v-if="manage_brand_enabled" />
        <div class="data-table-th-90">
          <el-tooltip placement="top">
            <div slot="content">レポート名を変更</div>
            <el-button type="default" @click="openChangeReport('change_report', list.report_name, list.report_id, index)" size="small" style="padding: 9px 10px">
              <i class="el-icon-edit"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">レポートを削除</div>
            <el-button @click="deleteReport(list.report_name, list.report_id, index)" type="default" size="small" style="padding: 9px 10px">
              <i class="el-icon-delete"></i>
            </el-button>
          </el-tooltip>
        </div>
      </div>

      <infinite-loading spinner="spiral" :identifier="infiniteId" @infinite="infiniteHandler" v-if="view_report_enabled && permission.access">
        <div slot="no-more"></div>
        <div slot="no-results" style="font-size: 40px"></div>
      </infinite-loading>

    </div>

    <reportCreateDrawer :active_report_count="active_report_count" :create_report.sync="create_report" @loadReport="loadReport" @closeCreateReport="closeCreateReport" />
    <createList
      :create_list.sync="change_report"
      :type="'change_report'"
      :target_list_name="target_report_name"
      :target_list_id="target_report_id"
      :target_list_index="target_report_index"
      @changeReportName="changeReportName"
    />
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const loadReportAPI = root + "/api/report/load_report";
const loadMemberAPI = root + "/api/member/load_member";
const changeReportAPI = root + "/api/report/change_report";
const deleteReportAPI = root + "/api/report/delete_report";
const addMemberAPI = root + "/api/report/add_member";
const deleteMemberFromReportAPI = root + "/api/report/delete_member_report";
const exportListAPI = root + "/api/list/export_list";
import unpermitted from "./../unpermitted";
import memberDropdown from "../list/list_dropdown_member";
import brandDropdown from "../list//list_dropdown_brand";
import createList from "../list/createList";
import reportCreateDrawer from "./report_create_drawer";
import { handleApiResponse, ERROR_MESSAGES } from "@/components/common/responseHelper";

export default {
  name: "report",
  components: {
    unpermitted,
    memberDropdown,
    brandDropdown,
    createList,
    reportCreateDrawer,
  },
  data() {
    return {
      tab_type: "report",
      list: [],
      member: [],
      target_client: [],
      create_report: false,
      create_report_id: "",
      report_name: "",
      sort_key: "",
      sort_order: "",
      result_count: 0,
      active_report_count: 0,
      offset: 0,
      infiniteId: +new Date(),
      nolist: "",
      count: 0,
      drawer: false,
      index: 0,
      search_report: "",
      search_report_regexp: "",
      requestId: 0,
      search_word: "",
      all_member: {
        person_id: "all",
      },
      all_client: {
        target_client_id: "all",
      },
      change_report: false,
      target_report_id: 0,
      target_report_index: 0,
      target_report_name: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    permission() {
      return this.$store.state.permission.report;
    },
    activate() {
      return this.$store.state.activate;
    },
    header_notification() {
      return this.$store.state.header_notification;
    },
    client_select() {
      return this.$store.state.client_select;
    },
    member_select() {
      return this.$store.state.member_select;
    },
    create_report_limit_num() {
      return this.$store.state.service_plan.create_report_limit_num;
    },
    view_report_enabled() {
      return this.$store.state.service_plan.view_report_enabled ? true : false;
    },
    manage_brand_enabled() {
      return this.$store.state.service_plan.manage_brand_enabled;
    },
    create_report_limited() {
      if (this.create_report_limit_num === null) return false;
      return this.active_report_count >= this.create_report_limit_num ? true : false;
    },
    isSideMenuClosed() {
      return this.$store.state.isSideMenuClosed;
    },
  },
  mounted() {
    this.$store.dispatch("changeActive", "report");
    this.loadMember();
    this.$nextTick(() => {
      this.infiniteId += 1;
    });
  },
  methods: {
    infiniteHandler($state) {
      this.axios.cancel(this.requestId);
      this.requestId += 1;
      this.axios
        .get(loadReportAPI, {
          requestId: this.requestId,
          params: {
            token: this.token,
            offset: this.offset,
            sort_key: this.sort_key,
            sort_order: this.sort_order,
            person_id: this.member_select.person_id,
            target_client_id: this.client_select.target_client_id,
            search_word: this.search_word,
          },
        })
        .then((response) => {
          if (this.offset == 0) {
            this.offset += 20;
            this.list = response.data.report;
            this.result_count = response.data.result_count;
            $state.loaded();
          } else {
            this.offset += 20;
            var newList = this.list.concat(response.data.report);
            this.list = newList;
            $state.loaded();
          }
          if (this.result_count <= this.offset) $state.complete();
          this.active_report_count = response.data.active_report_count;
          this.list.length == 0 ? (this.nolist = true) : (this.nolist = false);
          this.list.length == 0 ? (this.list[0] = "") : "";
        });
    },
    openCreateReport() {
      if (this.permission.access) {
        this.create_report = true;
        document.documentElement.style.overflow = "hidden";
        setTimeout(() => {
          document.getElementById("autoFocus").focus();
        }, 200);
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    closeCreateReport() {
      this.create_report = false;
      document.documentElement.style.overflow = "auto";
      this.loadReport();
    },
    loadReport() {
      this.axios
        .get(loadReportAPI, {
          params: {
            token: this.token,
            sort_key: this.sort_key,
            sort_order: this.sort_order,
            person_id: this.member_select.person_id,
            target_client_id: this.client_select.target_client_id,
          },
        })
        .then((response) => {
          this.list = response.data.report;
          this.list.length == 0 ? (this.nolist = true) : (this.nolist = false);
          this.list.length == 0 ? (this.list[0] = "") : "";
        });
    },
    loadMember() {
      this.axios
        .get(loadMemberAPI, {
          params: {
            token: this.token,
          },
        })
        .then((response) => {
          if (handleApiResponse(response)) {
            console.error(ERROR_MESSAGES.DATA_FETCH_ERROR);
            return;
          }
          this.member = response.data.member;
          this.target_client = response.data.target_client;
        });
    },
    selectMember(member) {
      this.$store.dispatch("selectMember", member);
      this.list = [];
      this.offset = 0;
      this.infiniteId += 1;
    },
    selectClient(client) {
      this.$store.dispatch("selectClient", client);
      this.list = [];
      this.offset = 0;
      this.infiniteId += 1;
    },
    changeTargetClient(value, id) {
      var params = new URLSearchParams();
      params.append("change_type", "target_client");
      params.append("target_client_id", value);
      params.append("report_id", id);
      params.append("token", this.token);
      this.axios.post(changeReportAPI, params).then((response) => {
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].report_id == id) {
            this.list[i].target_client_img_url = response.data.report_info.img_url;
            this.list[i].target_client_id = response.data.report_info.target_client_id;
            this.list[i].target_client_name = response.data.report_info.target_client_name;
          }
        }
      });
    },
    addMember(person_id, member_index, report_id, report_index) {
      if (this.permission.access) {
        var params = new URLSearchParams();
        params.append("person_id", person_id);
        params.append("report_id", report_id);
        params.append("token", this.token);
        this.axios.post(addMemberAPI, params).then(() => {
          this.list[report_index].member_count += 1;
          this.list[report_index].member[member_index].assign = true;
          this.list[report_index][person_id] = true;
        });
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    deleteClient(target_client_id, report_id, report_index) {
      var params = new URLSearchParams();
      params.append("member_type", "client");
      params.append("person_id", target_client_id);
      params.append("report_id", report_id);
      params.append("token", this.token);
      this.axios.post(deleteMemberFromReportAPI, params).then(() => {
        this.list[report_index].target_client_id = null;
        this.list[report_index].target_client_name = null;
        if (target_client_id == this.client_select.target_client_id) this.list.splice(report_index, 1);
      });
    },
    deleteMember(person_id, member_index, report_id, report_index) {
      if (this.permission.access) {
        var params = new URLSearchParams();
        params.append("member_type", "member");
        params.append("person_id", person_id);
        params.append("report_id", report_id);
        params.append("token", this.token);
        this.axios.post(deleteMemberFromReportAPI, params).then(() => {
          this.list[report_index].member_count -= 1;
          this.list[report_index].member[member_index].assign = false;
          this.list[report_index][person_id] = false;
          if (person_id == this.member_select.person_id) this.list.splice(report_index, 1);
        });
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    deleteReport(name, id, index) {
      if (this.permission.access) {
        const h = this.$createElement;
        const report_id = id;
        this.$msgbox({
          title: "レポート削除",
          type: "warning",
          message: h("p", null, [h("span", null, "「" + name + "」を削除しますか？"), h("br", null, ""), h("span", null, "この操作は取り消せません")]),
          showCancelButton: true,
          confirmButtonText: "削除",
          confirmButtonClass: "danger",
          cancelButtonText: "キャンセル",
        }).then(() => {
          var params = new URLSearchParams();
          params.append("report_id", report_id);
          params.append("token", this.token);
          this.axios.post(deleteReportAPI, params).then(() => {
            this.list.splice(index, 1);
            this.$message({
              type: "success",
              offset: 7,
              showClose: true,
              message: "「" + name + "」を削除しました",
            });
          });
        });
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    exportList() {
      this.$confirm("リスト一覧をエクスポートしますか？（リストはxlsx形式でエクスポートされます）", "リストエクスポート", {
        distinguishCancelAndClose: true,
        type: "info",
        confirmButtonText: "ダウンロード",
        cancelButtonText: "キャンセル",
      }).then(() => {
        location.href = exportListAPI + "?token=" + this.token;
      });
    },
    openReport(id) {
      this.$router.push({
        name: "reportDetail",
        params: {
          report_id: id,
        },
      });
    },
    openChangeReport(type, target_report_name, target_report_id, target_report_index) {
      if (this.permission.access) {
        this.target_report_name = target_report_name;
        this.target_report_id = target_report_id;
        this.target_report_index = target_report_index;
        this.change_report = true;
      } else {
        this.$store.dispatch("openUnpermittedDrawer", true);
      }
    },
    changeReportName(report_name, index) {
      this.list[index].report_name = report_name;
      this.target_report_name = "";
      this.target_report_id = 0;
      this.target_report_index = 0;
    },
    sortBy(value) {
      if (this.sort_key != value) {
        this.sort_order = "desc";
      } else {
        if (this.sort_order == "") {
          this.sort_order = "desc";
        } else if (this.sort_order == "asc") {
          this.sort_order = "desc";
        } else {
          this.sort_order = "asc";
        }
      }
      this.offset = 0;
      this.sort_key = value;
      this.list = [];
      this.infiniteId += 1;
    },
    toSetting() {
      this.$router.push("/setting");
    },
    imgError(index) {
      this.list[index].img_error = true;
    },
    createReportPageBack() {
      this.create_page -= 1;
    },
    createReportPageNext() {
      this.create_page += 1;
    },
    searchList(value) {
      this.search_word = value;
      this.nolist = false;
      this.list = [];
      this.offset = 0;
      this.infiniteId += 1;
    },
    sidemenuScroll() {
      this.$emit("sidemenuScroll");
    },
  },
  watch: {
    $route() {},
    list() {
      this.$forceUpdate();
    },
    report: {
      handler() {
        if (this.report.influencer_list.length >= 50) {
          this.report.trackingtag = "on";
        }
        if (this.report.trackingtag == "off") {
          this.hash_tag_json = [];
          this.mention_tag_json = [];
        }
      },
      deep: true,
    },
  },
  filters: {
    addComma(val) {
      return Math.floor(val).toLocaleString();
    },
    lastUpadate(val) {
      const now = new Date();
      const lastUpdate = new Date(val);
      const diffSec = now.getTime() - lastUpdate.getTime();
      if (diffSec / (1000 * 60 * 60 * 24) > 1) {
        const diffDay = Math.floor(diffSec / (1000 * 60 * 60 * 24)) + "日前";
        return diffDay;
      } else if (diffSec / (1000 * 60 * 60) > 1) {
        const diffHour = Math.floor(diffSec / (1000 * 60 * 60)) + "時間前";
        return diffHour;
      } else {
        const diffTime = Math.floor(diffSec / (1000 * 60)) + "分前";
        return diffTime;
      }
    },
    firstLetter(val) {
      return val.slice(0, 1);
    },
    // search_report(value) {
    //   return RegExp(value, "ig");
    // }
  },
};
</script>
